import React from 'react';
import { Select, SelectSizes } from '@clockout-dev/design-elements';
import { ClockCircleOutlined } from '@ant-design/icons';
import ConfigurationCard from '../../../../common/configurationCard/ConfigurationCard';
import { FEE_INSTANCE_OPTIONS } from '../../../configuration.constants';
import styles from '../styles/feeStructureForm.module.scss';

function FeeChargeInstanceCard({ value, enabled, onChange, onToggleEnabled }) {
    return (
        <ConfigurationCard
            title="Fee Charge Instance"
            icon={<ClockCircleOutlined />}
            enabled={enabled}
            onToggleEnabled={onToggleEnabled}
        >
            <Select
                id="feeInstance"
                size={SelectSizes.SMALL}
                value={value}
                options={FEE_INSTANCE_OPTIONS}
                onChange={onChange}
                className={styles.select}
            />
        </ConfigurationCard>
    );
}

export default FeeChargeInstanceCard;
